/*
* @Author: Irem Ercan
* @Date:   2018-01-04 20:32:31
* @Last Modified by:   Irem Ercan
* @Last Modified time: 2018-03-13 16:40:20
*/
import { closest } from '@jotforminc/utils';
import { forEach, addClass, removeClass, hasClass } from './utils';

export default class Overlay {

  constructor(params) {
    // Parameters
    this.questions = params.questions;
    this.hasSaveAndContinueLater = params.hasSaveAndContinueLater;

    // Elements
    this.overlayWrapper = document.querySelector('.js-overlayWrapper');
    this.saclModal = document.getElementById('sacl-modal');
    this.overlayImage = this.overlayWrapper.querySelector('.js-overlayImage');
    this.overlayClose = this.overlayWrapper.querySelector('.jfOverlay-close');

    // Bindings
    this.init = this.init.bind(this);
    this.bindOverlayEvents = this.bindOverlayEvents.bind(this);
    this.openSaveAndContinueModal = this.openSaveAndContinueModal.bind(this);
    this.closeSaveAndContinueModal = this.closeSaveAndContinueModal.bind(this);
    this.clearImageSrc = this.clearImageSrc.bind(this);
    this.openOverlay = this.openOverlay.bind(this);

    // Event Listeners
    this.overlayWrapper.addEventListener('click', (e) => {
      const closestDiv = closest(e.target, 'div');
      if (this.state === 'image' && hasClass(e.target, 'js-overlayImage')) {
        this.closeOverlay();
      } else if (this.state === 'sacl' && hasClass(closestDiv, 'js-overlay-modalWrapper')) {
        this.closeOverlay();
      }
    });
    this.overlayClose.addEventListener('click', () => {
      this.closeOverlay();
    });

    // Little state
    this.state = false;

    // Init
    this.init();
  }

  init() {
    if (this.questions) {
      this.overlayedQuestions = this.questions.filter(question => question.type === 'control_image');
      forEach(this.overlayedQuestions, (question) => {
        this.bindOverlayEvents(question);
      });
    }
  }

  openSaveAndContinueModal() {
    this.clearImageSrc();
    this.openOverlay();
    addClass(this.saclModal, 'isVisible');
    this.state = 'sacl';
  }

  closeSaveAndContinueModal() {
    removeClass(this.saclModal, 'isVisible');
  }

  bindOverlayEvents(question) {
    const ID = `id_${question.id}`;
    const imageWrapper = document.getElementById(ID);
    const imageElement = imageWrapper.querySelector('img');
    const imageSrc = imageElement.getAttribute('src');

    const _question = Object.assign({}, question, { src: imageSrc });

    const openNewTabButton = imageWrapper.querySelector('.js-openNewTab');
    if (openNewTabButton) {
      openNewTabButton.addEventListener('click', () => {
        this.openOverlay();
        this.openImageOverlay(_question);
        this.state = 'image';
      });
    }
  }

  clearImageSrc() {
    this.overlayImage.src = '#';
  }

  openOverlay() {
    addClass(this.overlayWrapper, 'isVisible');
  }

  openImageOverlay(question) {
    this.closeSaveAndContinueModal();
    this.overlayImage.src = question.src;
  }

  closeOverlay() {
    this.clearImageSrc();
    this.closeSaveAndContinueModal();
    this.state = false;
    removeClass(this.overlayWrapper, 'isVisible');
  }
}
